const SEATS_OPTIONS = {
    3: 3,
    5: 5,
    10: 10,
    15: 15,
    20: 20,
    25: 25,
    30: 30,
    40: 40,
    50: 50,
    100: 100,
    "200+": 200
};
const CONTACTS_OPTIONS = {
    2000: 2000,
    4000: 4000,
    7000: 7000,
    12000: 12000,
    27000: 27000,
    52000: 52000,
    60000: 60000
};
const MAX_NO_TOUCH_SEATS = 50;
const MAX_NO_TOUCH_CONTACTS = 60000;
const MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_PRO = 10;
const MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_PRO = 2000;
const MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE = 40;
const MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE = 60000;
export const UNIT_OF_MEASURE = {
    CONTACTS: "contacts",
    SEATS: "seats"
};
const UNIT_OF_MEASURE_OPTIONS = [
    {
        value: UNIT_OF_MEASURE.SEATS,
        text: "Seats"
    },
    {
        value: UNIT_OF_MEASURE.CONTACTS,
        text: "Contacts"
    }
];
const BUCKET_OPTIONS = {
    [UNIT_OF_MEASURE.CONTACTS]: CONTACTS_OPTIONS,
    [UNIT_OF_MEASURE.SEATS]: SEATS_OPTIONS
};
const MAX_NO_TOUCH_BUCKET_SIZE = {
    [UNIT_OF_MEASURE.CONTACTS]: MAX_NO_TOUCH_CONTACTS,
    [UNIT_OF_MEASURE.SEATS]: MAX_NO_TOUCH_SEATS
};
const MIN_BUCKET_SIZE_TO_RECOMMEND_PRO = {
    [UNIT_OF_MEASURE.CONTACTS]: MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_PRO,
    [UNIT_OF_MEASURE.SEATS]: MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_PRO
};
const MIN_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE = {
    [UNIT_OF_MEASURE.CONTACTS]: MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE,
    [UNIT_OF_MEASURE.SEATS]: MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE
};
const UNIT_OF_MEASURE_LABELS = {
    [UNIT_OF_MEASURE.CONTACTS]: "pricingPage.contacts",
    [UNIT_OF_MEASURE.SEATS]: "pricingPage.seats"
};
const UNIT_OF_MEASURE_SELECTOR_LABELS = {
    [UNIT_OF_MEASURE.CONTACTS]: "pricingPage.numberOfContacts",
    [UNIT_OF_MEASURE.SEATS]: "pricingPage.chooseTeamSize"
};
const PRICING_TYPES = {
    FIXED: "fixed",
    PER_UNIT: "per-unit"
};
module.exports = {
    SEATS_OPTIONS,
    CONTACTS_OPTIONS,
    UNIT_OF_MEASURE,
    UNIT_OF_MEASURE_OPTIONS,
    BUCKET_OPTIONS,
    MAX_NO_TOUCH_BUCKET_SIZE,
    MAX_NO_TOUCH_SEATS,
    MAX_NO_TOUCH_CONTACTS,
    MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_PRO,
    MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_PRO,
    MIN_SEATS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE,
    MIN_CONTACTS_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE,
    MIN_BUCKET_SIZE_TO_RECOMMEND_PRO,
    MIN_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE,
    UNIT_OF_MEASURE_LABELS,
    UNIT_OF_MEASURE_SELECTOR_LABELS,
    PRICING_TYPES
};
